import {Box, Button, Text, Title} from '@mantine/core';
import {InvalidTokenError} from '@packages/utils';
import Head from 'next/head';
import {useRouter} from 'next/router';
import {parseCookies} from 'nookies';
import {type FC, useState} from 'react';
import {routes} from '../../../../config/constants';
import {COLOR_LINK_1} from '../../../../config/constants/colorCodes';
import {GSSKT_HOST} from '../../../../config/constants/hosts';
import {deleteLineAccount} from '../../../../core/repositories/externalServicesRepository';
import {useIsSessionExpired} from '../../../../core/usecases/auth/useIsSessionExpired';

type Props = Record<string, never>;

export const UnlinkPage: FC<Props> = () => {
  const router = useRouter();
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.pathname)}`;
  const [unlink, setUnlink] = useState(false);
  const {updateIsSessionExpired} = useIsSessionExpired();

  const handleUnlink = async () => {
    const cookies = parseCookies();
    const res = await deleteLineAccount({cookies});
    if (!res.ok && res.error === InvalidTokenError) {
      updateIsSessionExpired(true);
    }

    if (!res.ok) {
      throw new Error(res.error);
    }

    setUnlink(true);
  };

  return (
    <>
      <Head>
        <title key="title">外資就活ドットコム - LINE 連携解除</title>
        <meta key="og:title" property="og:title" content="LINE連携完了" />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <link rel="canonical" href={currentUrl} key="canonical" />
        <meta name="robots" content="noindex" />
      </Head>
      <Box className="w-full max-w-[664px]">
        <Title
          order={1}
          className="border-t-4 border-link-1 bg-white p-16 text-lg text-link-1 pc:px-32"
        >
          {unlink
            ? '外資就活ドットコム - LINE 連携解除完了'
            : '外資就活ドットコム - LINE 連携解除'}
        </Title>
        <Box
          className=" bg-white px-8 pc:px-32"
          sx={() => ({
            paddingBottom: '16px',
            fontSize: '14px',
            lineHeight: '24px',
          })}
        >
          <Text>
            {unlink
              ? '外資就活ドットコムとLINEの連携を解除しました。'
              : '外資就活ドットコムとLINEの連携を解除します。\n連携を解除すると、LINEメッセージでの外資就活からのスカウト通知の受信ができなくなります。'}
          </Text>
          {!unlink && (
            <Button
              fullWidth
              variant="outline"
              mt={16}
              styles={() => ({
                label: {
                  color: COLOR_LINK_1,
                },
                root: {
                  borderColor: COLOR_LINK_1,
                },
              })}
              onClick={() => {
                void handleUnlink();
              }}
            >
              連携を解除
            </Button>
          )}
          {unlink ? (
            <Button
              fullWidth
              variant="outline"
              mt={16}
              styles={() => ({
                label: {
                  color: COLOR_LINK_1,
                },
                root: {
                  borderColor: COLOR_LINK_1,
                },
              })}
              onClick={() => {
                location.href = routes.HOME;
              }}
            >
              ホームに戻る
            </Button>
          ) : (
            <Button
              fullWidth
              variant="light"
              mt={8}
              styles={() => ({
                label: {
                  color: COLOR_LINK_1,
                },
              })}
              onClick={() => {
                router.back();
              }}
            >
              キャンセル
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};
